import { render } from "./CollectionModuleLandingComponent.vue?vue&type=template&id=2929aa70&scoped=true"
import script from "./CollectionModuleLandingComponent.vue?vue&type=script&lang=js"
export * from "./CollectionModuleLandingComponent.vue?vue&type=script&lang=js"

import "./CollectionModuleLandingComponent.vue?vue&type=style&index=0&id=2929aa70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2929aa70"]])

export default __exports__